import { useEffect, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import css from "./PreviewPDF.module.scss";
import { useUploadFile } from "./uploadFileContainer";
import { isEmpty } from "lodash";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

/**
 * PDF 预览组件
 * @returns
 */
export default function PreviewPDF() {
  const { uploadFileProps, setPreviewState, previewState, fileStatus } = useUploadFile();
  const { dropUploadFileData } = uploadFileProps;
  const { loading, previewURL } = previewState;

  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [emptyPDF, setEmptyPDF] = useState(false);

  function onDocumentLoadSuccess({ numPages }: any) {
    setNumPages(numPages);
  }

  // 本地预览
  useEffect(() => {
    if (fileStatus === "success" && dropUploadFileData.fileData) {
      const url = URL.createObjectURL(dropUploadFileData.fileData);
      URL.revokeObjectURL(dropUploadFileData.fileData);
      setPreviewState({ loading: false, previewURL: url });
    }
  }, [fileStatus, dropUploadFileData]);

  const Loading = <div className={css["pdf-loading"]}>Transcription ...</div>;

  if (emptyPDF) {
    return (
      <div className={css["preview-loading-wrap"]}>
        <div className={css["pdf-loading"]}>No Data</div>
      </div>
    );
  }

  return (
    <SimpleBar className={css["preview-wrap"]} autoHide forceVisible>
      {previewURL ? (
        <Document
          className={css["pdf-document"]}
          file={previewURL}
          loading={loading ? Loading : ""}
          onLoadSuccess={onDocumentLoadSuccess}
          onError={() => {
            setEmptyPDF(true);
          }}
        >
          <Page
            // 不渲染预览
            renderMode="none"
            // 不渲染注释层
            renderAnnotationLayer={false}
            pageNumber={pageNumber}
            loading={loading ? Loading : ""}
            onGetTextSuccess={(props: any) => {
              if (isEmpty(props.items)) {
                if (pageNumber <= (numPages as unknown as number)) {
                  setPageNumber(pageNumber + 1);
                } else {
                  setEmptyPDF(true);
                }
              }
            }}
            onLoadError={() => {
              setEmptyPDF(true);
            }}
          />
        </Document>
      ) : (
        Loading
      )}

      {/* <div>
        {PDFPreviewText}
      </div> */}
    </SimpleBar>
  );
}
